// extracted by mini-css-extract-plugin
module.exports = {"incompleteImg":"styles_incompleteImg__3KYtz","dialogPaper":"styles_dialogPaper__1mt1i","finishButton":"styles_finishButton__3vF_U"};